/* BuyMyBricks home page: reels, the wall (Show all + theme chips) and card buttons.
   Mirrors the inline script in prototype/render.mjs home(). */
(function () {
  // Reels: arrows scroll the track.
  document.querySelectorAll('.reel').forEach(function (r) {
    var t = r.querySelector('.reel__track');
    var l = r.querySelector('.reel__nav--l'), rt = r.querySelector('.reel__nav--r');
    if (l) l.addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth * 0.8, behavior: 'smooth' }); });
    if (rt) rt.addEventListener('click', function () { t.scrollBy({ left: t.clientWidth * 0.8, behavior: 'smooth' }); });
  });

  // The wall. Liquid renders the first 48; the rest arrive from the collection's minicards
  // view (50 per page, every page fetched at once) the first time they are needed.
  var wall = document.getElementById('wall'), more = document.getElementById('wall-more'), count = document.getElementById('wall-count');
  if (!wall || !more) return;
  var all = false, loaded = false, loading = null, theme = 'All';
  function cards() { return Array.prototype.slice.call(wall.children); }
  function apply() {
    var shown = 0;
    cards().forEach(function (c) {
      var ok = theme === 'All' || c.dataset.theme === theme;
      var vis = ok && (all || theme !== 'All' || shown < 60);
      c.classList.toggle('is-hidden', !vis); if (ok) shown++;
    });
    more.style.display = (theme === 'All' && !all) ? '' : 'none';
  }
  function loadAll() {
    if (loaded) return Promise.resolve();
    if (loading) return loading;
    var src = wall.dataset.source, pages = Number(wall.dataset.pages) || 1, reqs = [];
    more.disabled = true; more.textContent = 'Loading';
    for (var p = 1; p <= pages; p++) reqs.push(fetch(src + '&page=' + p, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }));
    loading = Promise.all(reqs).then(function (parts) {
      var seen = {};
      cards().forEach(function (c) { if (c.dataset.set) seen[c.dataset.set] = 1; });
      var box = document.createElement('div');
      box.innerHTML = parts.join('');
      Array.prototype.slice.call(box.querySelectorAll('.card--mini')).forEach(function (c) {
        var k = c.dataset.set || c.getAttribute('href');
        if (seen[k]) return;          // one card per set number, the first listing wins
        seen[k] = 1;
        wall.appendChild(c);
      });
      loaded = true;
      if (count) count.textContent = cards().length;
      more.disabled = false;
    }).catch(function () { more.disabled = false; more.textContent = 'Show all'; loading = null; });
    return loading;
  }
  more.addEventListener('click', function () { loadAll().then(function () { all = true; apply(); }); });
  document.querySelectorAll('.chip--filter').forEach(function (b) {
    b.addEventListener('click', function () {
      theme = b.dataset.theme;
      document.querySelectorAll('.chip--filter').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      if (theme === 'All') { apply(); return; }
      loadAll().then(apply);
    });
  });
  apply();
})();
